import {getShortId} from "utils/misc";

// Incident Detail
export const selectIncidentDetailId = (state) => state.incidentDetail.id;
export const selectIncidentDetailShortId = (state) =>
  getShortId(state.incidentDetail.id);
export const selectIncidentDetail = (state) => state.incidentDetail.incident;
export const selectIncidentDescription = (state) =>
  state.incidentDetail.incident.description;
export const selectIncidentSource = (state) =>
  state.incidentDetail.incident.source;
export const selectHasIncident = (state) =>
  !!Object.keys(state.incidentDetail.incident).length;
export const selectIncidentLoading = (state) =>
  state.incidentDetail.loadingIncident;
export const selectIncidentLoadingWithBundle = (state) =>
  state.incidentDetail.loadingIncident && state.incidentDetail.loadingBundle;
export const selectIncidentIsRefreshing = (state) =>
  state.incidentDetail.refreshing;
export const selectDisableIncidentEditing = (state) =>
  state.incidentDetail.loadingIncident || state.incidentDetail.refreshing;

// WorkLog
export const selectIncidentAuditLogLoading = (state) =>
  state.incidentDetail.loadingIncidentAuditLog;
export const selectIncidentAuditLog = (state) => state.incidentDetail.auditLog;
export const selectAuditLogTotalCount = (state) =>
  state.incidentDetail.auditLogTotalCount;
export const selectIncidentNotes = (state) => state.incidentDetail.notes;
export const selectIncidentNotesTotalCount = (state) =>
  state.incidentDetail.notesTotalCount;
export const selectIncidentNotesLoading = (state) =>
  state.incidentDetail.loadingNotes;
export const selectIncidentNoteSaving = (state) =>
  state.incidentDetail.savingNote;
